import { Matrix } from "../../maths/Matrix";
import { Pool } from "../../utils/Pool";
const className = "RotateCmd";
export class RotateCmd {
    static create(angle, pivotX, pivotY) {
        var cmd = Pool.getItemByClass(className, RotateCmd);
        cmd.angle = angle;
        cmd.pivotX = pivotX;
        cmd.pivotY = pivotY;
        return cmd;
    }
    recover() {
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        runner._rotate(this.angle, this.pivotX + gx, this.pivotY + gy);
    }
    getBounds(assembler) {
        tempMatrix.identity();
        tempMatrix.translate(-this.pivotX, -this.pivotY);
        tempMatrix.rotate(this.angle);
        tempMatrix.translate(this.pivotX, this.pivotY);
        assembler.concatMatrix(tempMatrix);
    }
    get cmdID() {
        return RotateCmd.ID;
    }
}
RotateCmd.ID = className;
const tempMatrix = new Matrix();
